import { type FC } from "react";
import Segments from "components/navigation/segments/Segments";
import { DetailsHeader } from "../../../components/sectionHeader";
import OnedriveReport from "./Onedrive/OnedriveReport";
import SharepointReport from "./Sharepoint/SharepointReport";
import TeamsReport from "./Teams/TeamsReport";
import CopilotReport from "./Copilot/CopilotReport";
import { Navigate, Route, Routes } from "react-router";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";
import styles from "./graphReport.module.scss";

export const GraphReport: FC = () => {
  const isMicrosoftGraphReportsEnabled = !!useFeatureFlag(FeatureFlags.MicrosoftGraphReports);
  const isCopilotReportEnabled = !!useFeatureFlag(FeatureFlags.CopilotReport);

  const pages = [
    { to: "teams", label: "Teams" },
    { to: "onedrive", label: "OneDrive" },
    { to: "sharepoint", label: "SharePoint" },
    ...(isCopilotReportEnabled ? [{ to: "copilot", label: "M365 Copilot" }] : []),
  ];

  if (!isMicrosoftGraphReportsEnabled) {
    return <ReportUnavailable />;
  }

  return (
    <div className="nested-content">
      <DetailsHeader title="Microsoft Graph" showReportLastUpdated />
      <Segments to={"/reporting/graph"}>
        {pages.map((page, i) => (
          <Segments.Segment key={i} {...page} />
        ))}
      </Segments>

      <div className={styles.scrollable}>
        <Routes>
          <Route path="teams" element={<TeamsReport />} />
          <Route path="onedrive" element={<OnedriveReport />} />
          <Route path="sharepoint" element={<SharepointReport />} />
          {isCopilotReportEnabled && <Route path="copilot" element={<CopilotReport />} />}
          <Route path="*" element={<Navigate to="../teams" replace />} />
        </Routes>
      </div>
    </div>
  );
};
